import { Roles } from "../../mp-utils/generic-utils"
import { FILTER_TYPES } from "../../mp-core/components/AppFilters/filters.data"
import { FiltersState, ManagePages } from "../types"

export const REQUIRED_FILTERS = {
  [Roles.Super_Administrator]: {
    [ManagePages.DistrictAdmins]: ["districtId"],
    [ManagePages.Schools]: ["districtId"],
    [ManagePages.SchoolAdmins]: ["districtId", "schoolId"],
    [ManagePages.Teachers]: ["districtId", "schoolId"],
    // Removing "schoolId" and "teacherId" from here, because it has different API and rules now.
    [ManagePages.Classes]: ["districtId"],
    [ManagePages.Students]: ["districtId", "schoolId"]
  },
  [Roles.District_Admin]: {
    [ManagePages.SchoolAdmins]: ["schoolId"],
    [ManagePages.Teachers]: ["schoolId"],
    // Removing "Classes" page from here, because it has different API and rules now.
    [ManagePages.Students]: ["schoolId"]
  },
  [Roles.School_Admin]: {
    // Removing "Classes" page from here, because it has different API and rules now.
  }
}

export const checkRequiredFilters = (
  role: string,
  page: string,
  filters: Omit<FiltersState, "hasRequired">
): boolean =>
  REQUIRED_FILTERS[role]?.[page]?.every(filter => filters[filter]) ?? true

export const getPageFilters = (page: string) => {
  switch (page) {
    case "district-admins":
    case "schools":
      return [FILTER_TYPES.district]
    case "school-admins":
    case "teachers":
      return [FILTER_TYPES.district, FILTER_TYPES.school]
    case "classes":
      return [FILTER_TYPES.district, FILTER_TYPES.school, FILTER_TYPES.teacher]
    case "students":
      return [
        FILTER_TYPES.district,
        FILTER_TYPES.school,
        FILTER_TYPES.teacher,
        FILTER_TYPES.class
      ]

    default:
      return [
        FILTER_TYPES.district,
        FILTER_TYPES.school,
        FILTER_TYPES.teacher,
        FILTER_TYPES.class
      ]
  }
}

export const getFiltersForManagePage = (role: string, page: string) => {
  const filters = getPageFilters(page)

  switch (role) {
    case Roles.Super_Administrator: {
      return {
        filters,
        disabledActionsFilters: []
      }
    }
    case Roles.District_Admin: {
      return {
        filters,
        disabledActionsFilters: ["district"]
      }
    }
    case Roles.School_Admin: {
      return {
        filters,
        disabledActionsFilters: ["district", "school"]
      }
    }
    case Roles.Teacher: {
      return {
        filters,
        disabledActionsFilters: ["district", "school", "teacher"]
      }
    }
    default:
      return { filters, disabledActionsFilters: [] }
  }
}
